import React from 'react';
import { T } from 'shared/helper/translate';
var PlagiarismStrip = function PlagiarismStrip(_ref) {
  var title = _ref.title,
    poweredBy = _ref.poweredBy,
    logo = _ref.logo,
    price = _ref.price,
    priceNote = _ref.priceNote,
    featuresTerm = _ref.featuresTerm,
    action = _ref.action;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-strip d-flex align-items-center overflow-hidden bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pricing-strip-title p-4 flex-shrink-0"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "fw-bold mb-1"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "pricing-powered-by d-flex align-items-center"
  }, poweredBy, " ", /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "iThenticate"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "pricing-divider align-self-stretch flex-shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pricing-strip-price py-4 flex-shrink-0 text-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "pricing-price fw-bold lh-1"
  }, price), /*#__PURE__*/React.createElement("span", {
    className: "d-block mt-1 fw-semibold"
  }, priceNote)), /*#__PURE__*/React.createElement("div", {
    className: "pricing-divider align-self-stretch flex-shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pricing-strip-feature-list flex-grow-1"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: featuresTerm
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex-shrink-0"
  }, action));
};
export default PlagiarismStrip;